<template>
  <div class="email-history-details-body">
    <div class="choose-event-wrapper row">
      <div class="col-md-3">
        <div class="h3-text">Event Type</div>
        <div class="event-type">
          {{historyDetails.singleEvent == true ? "Single Event" : "Related Event (" + historyDetails.relatedEvents.length + " events)"}}
        </div>
      </div>
      <div class="col-md-5">
        <div class="h4-text">Events</div>
        <div class="group-related-events">
          <div v-for="reEvent in historyDetails.relatedEvents" :key="reEvent.id" class="related-event-item">
            <div class="event-name" @click="relatedEventItemClick(reEvent.id)">{{reEvent.eventName}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="recipients-wrapper row">
      <div class="recipients-section col-md-8">
        <div class="h3-text">Recipients (To)</div>
        <div class="list-email-recipient">
          <div class="list-email-send-to">
            <div class="body-text" v-if="listEmailSendTo.length == 0">
              N/A
            </div>
            <div v-else>
              <div v-for="e in listEmailSendTo" :key="e" class="email-item">
                <div class="text">{{e}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cc-section col-md-4">
        <div class="h3-text">Additional Recipients (CC)</div>
        <div class="list-email-recipient">
          <div class="list-email-send-to">
            <div class="body-text" v-if="listEmailCC.length == 0">
              N/A
            </div>
            <div v-else>
              <div v-for="e in listEmailCC" :key="e" class="email-item">
                <div class="text">{{e}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="email-template-wrapper">
      <div class="choose-email-template">
        <div class="h3-text">Email Template</div>
        <div class="template-value body-text">
          {{historyDetails.templateType | templateName}}
        </div>
      </div>
      <div class="email-body-section">
        <div class="h3-text">Email Body</div>
        <div class="row email-body-container ck-for-email-history-detail">
          <div class="col-md-8">
            <!-- <div class="email-body-content body-text" v-html="historyDetails.templateBody">
            </div> -->
            <vue-ckeditor
              v-model="historyDetails.templateBody"
              :config="config" @focus="ckEditorFocus" ></vue-ckeditor>
          </div>
          <div class="reply-and-history-section col-md-4">
            <div class="reply-emails-wrapper">
              <div class="h4-text">Reply emails go to:</div>
              <div class="list-email-recipient">
                <div class="list-email-send-to">
                  <div class="body-text" v-if="listReplyEmails.length == 0">N/A</div>
                  <div v-else>
                    <div class="email-item" v-for="e in listReplyEmails" :key="e">
                      <div class="text">{{e}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import Icon from 'vue-awesome/components/Icon';
  import PrettyRadio from 'pretty-checkbox-vue/radio';
  import emailTemplateConsts from '@/store/constants/emailTemplateType';
  // import ModalChangeEmailTemplate from '@/components/modal/ModalChangeEmailTemplate';
  // import consts from '@/_consts';
  import 'vue-awesome/icons/sort';
  import VueCkeditor from 'vue-ckeditor2';

  export default {
    name: 'email-history-details',
    components: {
      Icon,
      PrettyRadio,
      VueCkeditor
    },
    data () {
      return {
        listEmailCC: [],
        listEmailSendTo: [],
        listReplyEmails: '',
        listHistory: [],
        replyEmail: '',
        ccEmail: '',
        recipientEmail: '',
        selectedTemplate: emailTemplateConsts.day60,
        emailTemplates: [],
        emailTemplateConsts: emailTemplateConsts,
        id: null,
        eventId: null,
        selectedTemplateOldValue: emailTemplateConsts.day60,
        historyDetails: {
          relatedEvents: []
        },
        event: {},
        config: {
          toolbar: [
          ],
          height: 400,
          allowedContent: true,
          readOnly: true,
          removePlugins: 'elementspath, toolbar',
          resize_enabled: false
        }
      };
    },
    computed: {
    },
    filters: {
    },
    props: {
    },
    methods: {
      closeModalChangeMailTemplate (changeTemplate) {
        if (changeTemplate) {
          this.setSelectedTemplate();
        } else {
          this.selectedTemplate = this.selectedTemplateOldValue;
        }
      },
      relatedEventItemClick (eventId) {
        let url = window.location.origin + '/#/event/' + eventId;
        window.open(url, '_blank');
      },
      addReplyEmailGoTo () {
        if (this.replyEmail === '') {
          return;
        }
        this.listReplyEmails = this.replyEmail;
        this.replyEmail = '';
      },
      ckEditorFocus (e) {
        this.isChangedEditor = true;
      },
      getEmailTemplate (isSingleEvent, isDefault) {
        this.getDefaultEmailTemplate({
          eventId: this.eventId || this.$route.params.eventId,
          isSingleEvent: isSingleEvent
        }).then((response) => {
          this.emailTemplates = response.templates;
          if (isDefault) {
            this.selectedTemplate = emailTemplateConsts.day60;
          }
          this.setSelectedTemplate(isSingleEvent, false);
        });
      },
      setSelectedTemplate () {
        if (this.selectedTemplate === emailTemplateConsts.day60) {
          this.body = this.emailTemplates[0].body;
        }
        if (this.selectedTemplate === emailTemplateConsts.day30) {
          this.body = this.emailTemplates[1].body;
        }
        if (this.selectedTemplate === emailTemplateConsts.day7) {
          this.body = this.emailTemplates[2].body;
        }
        if (this.selectedTemplate === emailTemplateConsts.thankyou) {
          this.body = this.emailTemplates[3].body;
        }
        this.selectedTemplateOldValue = this.selectedTemplate;
      },
      removeRecipient (email) {
        let index = this.listEmailSendTo.indexOf(email);
        if (index >= 0) {
          this.listEmailSendTo.splice(index, 1);
        }
      },
      removeRecipientCC (email) {
        let index = this.listEmailCC.indexOf(email);
        if (index >= 0) {
          this.listEmailCC.splice(index, 1);
        }
      },
      goToEmailHistoryDetails (id) {
        // GO to email detail
        this.$router.push({name: 'EmailHistoryDetailsManagement',
          params: {
            id: id,
            eventId: this.eventId
          }
        });
      },
      viewAllMailHistories () {
        this.$router.push({name: 'EmailHistoriesManagement', params: {eventId: this.eventId}});
      },
      ...mapActions({
        getEmailHistoryDetails: 'ACTION_GET_EMAIL_HISTORY_DETAILS'
      })
    },
    watch: {
    },
    created () {
      if (this.$route.params && this.$route.params.id) {
        this.id = this.$route.params.id;
        this.eventId = this.$route.params.eventId;
        this.getEmailHistoryDetails(this.id).then((response) => {
          this.historyDetails = response.historyDetail;
          this.listEmailSendTo = response.historyDetail.recipients === '' ? [] : response.historyDetail.recipients.split(',');
          this.listEmailCC = response.historyDetail.additionalRecipients === '' ? [] : response.historyDetail.additionalRecipients.split(',');
          this.listReplyEmails = response.historyDetail.senderEmail === '' ? [] : response.historyDetail.senderEmail.split(',');
        });
      }
    },
    mounted () {
    }
  }
</script>
<style type="text/css">

</style>





// WEBPACK FOOTER //
// EmailHistoryDetails.vue?78173b9c